import React from 'react';
import { Tooltip, TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './setupClicksEventCategory.module.scss';

export const MultiButtonMessage = ({ buttonNames = [] }) => {
    const { formatMessage } = useIntl();

    if (buttonNames.length === 0) {
        return null;
    }

    const cleanedButtonNames = buttonNames.map(name => name.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim());

    let displayText = '';
    let suffix = '';
    let hasOverflow = false;
    const maxTotalChars = 103;

    const isSingleButton = cleanedButtonNames.length === 1;
    const buttonText = isSingleButton
        ? `'${cleanedButtonNames[0]}'`
        : cleanedButtonNames.map(name => `'${name}'`).join(', ');

    const fullSuffix = formatMessage({
        id: 'codeless.setup.clicks.button.selected.suffix',
        defaultMessage: ' - Button was selected',
    });
    const cutSuffix = formatMessage({
        id: 'codeless.setup.clicks.button.selected.cut.suffix',
        defaultMessage: '...- Button was selected',
    });

    const fullText = buttonText + fullSuffix;

    if (fullText.length <= maxTotalChars) {
        displayText = buttonText;
        suffix = fullSuffix;
        hasOverflow = false;
    } else {
        const maxCharsForButton = maxTotalChars - cutSuffix.length;
        displayText = buttonText.substring(0, maxCharsForButton) + '...';
        suffix = formatMessage({
            id: 'codeless.setup.clicks.button.selected.overflow.suffix',
            defaultMessage: '- Button was selected',
        });
        hasOverflow = true;
    }

    const indicationContent = (
        <div className={styles['multi-button-message']}>
            <strong className={styles['tooltip-wrapper']}>{displayText}</strong>
            <span className={styles['suffix']}>{suffix}</span>
        </div>
    );

    if (hasOverflow) {
        return (
            <Tooltip
                position={TOOLTIP_POSITION.RIGHT}
                content={
                    <div className={styles['tooltip-content']}>
                        {isSingleButton
                            ? `'${cleanedButtonNames[0]}'`
                            : cleanedButtonNames.map(name => `'${name}'`).join(', ')}
                    </div>
                }
            >
                {indicationContent}
            </Tooltip>
        );
    }

    return indicationContent;
};
